
import useMetaIcons from "~/mixins/useMetaIcons";
import useGtm from "~/mixins/useGtm";

export default {
  mixins: [
    useMetaIcons,
    useGtm,
  ],
  head() {
    const metaIconsHead = useMetaIcons.head.call(this);
    const gtmHead = useGtm.head.call(this);

    return {
      link: [...(metaIconsHead.link || [])],
      meta: [...(gtmHead.meta || [])],
    };
  },
};
